<template>
  <div>
    <PageAppBar>Updates</PageAppBar>
    <div v-if="!message" class="page-content header-clear-small">
      <div v-if="!Object.keys(updates).length">
        <mushonga></mushonga>
      </div>

      <div v-for="course in updates.data.data" v-else :key="(course.id)">
        <div>
          <div class="card card-style">
            <div class="card card-style mx-0 rounded-0 mb-0 preload-img" data-card-height="200"
                 data-src="https://picsum.photos/200/300"
                 :style="'height: 200px; background-image: url(&quot;'+image_url+course.photo+'&quot;);'">
              <div class="card-bottom ml-3 mb-3">
                <h1 class="color-white mb-0">{{ course.title }}</h1>
              </div>
              <div class="card-overlay bg-black opacity-70"></div>
            </div>
            <div class="content">
              <p>{{ course.body }}</p>
            </div>
          </div>
        </div>
      </div>
      <FooterBar></FooterBar>
    </div>
  </div>
</template>

<script>
// import FooterBar from "@/components/FooterBar";
// import PageAppBar from "@/components/PageAppBar";
// import Google from "vue-loading-spinner/src/components/Google";

import axios from "axios";
import global from "@/mixins/global";
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";

export default {
  components: {FooterBar, PageAppBar},
  // components: {PageAppBar, FooterBar},
  mixins: [global],
  mounted() {
    axios.get(this.base_url + "updates", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response => {
      this.updates = response
    }).catch(error => {
      this.error = error
    })
  },
  data() {
    return {
      updates: [],
      update: {}
    }
  },

  computed: {
    pageTitle() {
      return this.$route.path
    }
  }
}
</script>

<style>
.header-clear-small {
  padding-top: 60px;
}

.text-center {
  align-items: center;
}
</style>
